export const OPTHINES = {
         voteName: '2020project/2020economics',
         mustSearch: 'Button',
         buttonBg: 'rgb(213, 153, 48)',
         number: {
           mustRank: true,
         },
         name: true,
         content: true,
         user: true,
         checkBox: false,
         themeColor: {
           activeBgColor: '#fdc674',
           inactiveBgColor: '#afafaf',
         },
         tabs: [
           {
             tabName: '评选规则',
             tabPath: '/20200409JJRW/rules',
           },
           {
             tabName: '相关新闻',
             tabPath: '/20200409JJRW/news',
           },
           {
             tabName: '参评展示',
             tabPath: '/20200409JJRW/List',
           },
         ],
       };
